import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-[75vh] bg-[#F8FAFC] flex items-center justify-center pt-28 pb-20 px-4">
      <div className="max-w-xl w-full bg-white rounded-3xl p-8 sm:p-12 text-center shadow-lg border border-slate-200 space-y-6">
        <div className="w-20 h-20 bg-[#1D352E]/10 text-[#65237e] rounded-3xl flex items-center justify-center mx-auto text-3xl font-extrabold">
          404
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1D352E]">
            Siden blev ikke fundet
          </h1>
          <p className="text-gray-600 text-base">
            Beklager, men den side du leder efter eksisterer ikke eller er blevet flyttet.
          </p>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto px-6 py-3 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl transition-colors shadow-sm text-center"
          >
            Gå til Forsiden
          </Link>
          <Link
            to="/ydelser"
            className="w-full sm:w-auto px-6 py-3 text-sm font-semibold text-[#1D352E] bg-[#F1F5F9] hover:bg-gray-200 rounded-xl transition-colors text-center"
          >
            Se Vores Ydelser
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto px-6 py-3 text-sm font-semibold text-[#1D352E] bg-[#F1F5F9] hover:bg-gray-200 rounded-xl transition-colors text-center"
          >
            Kontakt Os
          </Link>
        </div>
      </div>
    </div>
  );
}
